import gridView from '@/global/components/grid/GridView.vue'
import idCardsGridBlock from '../../components/idCardsGridBlock.vue'
import { api } from '@/global/services/api'
import { registeredTableHandlers } from '@/global/components/view-layouts/tabs-layout/config/registered-table-handlers'
import { showDetailsAction, deleteAction } from '@/global/components/table/helpers/tableActions'

export default {
  name: 'idCards',

  computed: {
    idCardsConfig () {
      return {
        title: this.$t('people/person.cards'),
        key: 'idCards',
        onTabChange: () => {
          this.showMainEditButtons = false
        },
        tabContent: [
          {
            component: this.tableGridComponent,
            editable: false,
            apiConfig: {
              get: {
                module: 'people',
                route: 'person-cards',
                method: 'get',
                queryParams: {
                  person_id: this.$route.params.id
                }
              }
            },
            rowDblClick: (event) => this.onShowCard(event),
            mobileConfig: {
              title: this.$t('people/person.cards')
            },
            title_and_back_config: {
              title: this.$t('people/person.cards')
            },
            search_and_buttons_config: {
              newClick: () => this.onNewCard()
            },
            gridConfig: {
              component: gridView,
              blockConfig: {
                component: idCardsGridBlock,
                onEdit: (event) => this.onShowCard(event),
                onDelete: (event) => this.onCardDelete(event)
              },
              useBorder: false
            },
            tableConfig: {
              cellsConfig: {
                type: {
                  custom_display_value: (item) => {
                    return item?.type?.name || ''
                  }
                }
              },
              headers: [
                {
                  label: this.$t('people/person.id_card_type'),
                  key: 'type',
                  always_visible: true
                },
                {
                  label: this.$t('people/person.pin_code'),
                  key: 'value',
                  always_visible: true
                }
              ],
              actionsConfig: [
                showDetailsAction(this.$t, (event) => this.onShowCard(event)),
                deleteAction(this.$t, (event) => this.onCardDelete(event))
              ],
              paginationConfig: {
                perPageOptions: [5, 10, 20, 50, 100]
              },
              filtersConfig: {
                fields: [
                  {
                    key: 'type',
                    label: this.$t('people/person.id_card_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'people',
                      route: 'id-cards/autocomplete'
                    }
                  },
                  {
                    key: 'value',
                    label: this.$t('people/person.pin_code')
                  }
                ]
              }
            }
          }
        ]
      }
    }
  },

  methods: {
    onNewCard () {
      this.$set(this.manageIdCardsDialogConfig, 'title', this.$t('people/person.adding_new_id_card'))
      this.$set(this.manageIdCardsDialogConfig, 'createMode', true)
      this.$set(this.manageIdCardsDialogConfig, 'editData', null)
      this.$set(this.manageIdCardsDialogConfig, 'show', true)
    },

    onShowCard (event) {
      const { data } = event || {}
      this.$set(this.manageIdCardsDialogConfig, 'title', this.$t('people/person.updating_id_card'))
      this.$set(this.manageIdCardsDialogConfig, 'createMode', false)
      this.$set(this.manageIdCardsDialogConfig, 'editData', data)
      this.$set(this.manageIdCardsDialogConfig, 'show', true)
    },

    onCardDelete (event) {
      const { name } = event?.data?.type || {}
      this.$set(this.informationDialogConfig, 'title', this.$t('people/person.delete_card_dialog_title') + ' - ' + name || '')
      this.$set(this.informationDialogConfig, 'message', this.$t('people/person.delete_card_dialog_message'))
      this.$set(this.informationDialogConfig, 'confirmCallbackFunction', async () => await this.deleteCardCallback(event))
      this.$set(this.informationDialogConfig, 'showDialog', true)
    },

    async deleteCardCallback (event) {
      try {
        const { id: deleteId } = event?.data || {}
        if (!deleteId) {
          return
        }

        await api('people').delete(`person-cards/${deleteId}`)
        const { fetchData } = registeredTableHandlers?.idCards || {}
        if (typeof fetchData === 'function') {
          fetchData()
        }
        this.$set(this.informationDialogConfig, 'showDialog', false)
      }
      catch (exception) {
        console.error(exception)
      }
    }
  }
}
